import { useCallback, useEffect, useState } from "react";

import { Ratio } from "@simplyk/common";

import { useWidth } from "@/common/hooks/useWidth";

interface UseImageUploaderSizingParams {
  ratio: Ratio;
  displayRatioValue: number | undefined;
  maxHeight: number | undefined;
}

export const useImageUploaderSizing = ({ ratio, displayRatioValue, maxHeight }: UseImageUploaderSizingParams) => {
  const [imageUploaderWidth, setImageUploaderWidth] = useState(0);
  const computedHeight =
    ratio === Ratio.Auto || ratio === Ratio.Free ? imageUploaderWidth : imageUploaderWidth / (displayRatioValue ?? 1);
  const imageUploaderHeight = maxHeight !== undefined ? Math.min(computedHeight, maxHeight) : computedHeight;
  const [imageUploaderRef, setImageUploaderRef] = useState<HTMLDivElement | null>(null);

  const handleSetImageUploaderRef = useCallback((ref: HTMLDivElement | null) => {
    setImageUploaderRef(ref);
  }, []);

  const { getWidths } = useWidth([imageUploaderRef]);
  useEffect(() => {
    const [columnWidth] = getWidths();
    setImageUploaderWidth(columnWidth);
  }, [getWidths]);

  return { imageUploaderHeight, handleSetImageUploaderRef };
};
